import styled from 'styled-components/macro';
import { FilterProps } from './types';
import Select from 'react-select';

export const Filter = styled.div<FilterProps>`
  min-width: 224px;
  width: ${({ width }) =>
    typeof width === 'string' ? width : `${width}px` || 'auto'};
`;

export const SelectInput = styled(Select)`
  position: relative;
  display: block;
  width: 499px;
  font-size: 16px;
  height: 40px;
  box-sizing: border-box;
  transition:
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  border: none;
  box-sizing: border-box;
  &:focus {
    color: #495057;
    background-color: ${({ theme }) => theme.colors.white['100']};
    outline: 0;
  }
`;

export const ClearSelect = styled.div`
  margin-left: 6px;
  padding-top: 3px;
  cursor: pointer;
`;

export const ItemContainer = styled.div`
  width: 100%;
`;

export const ItemDetails = styled.div<{ show: boolean }>`
  display: ${props => (props.show ? 'flex' : 'none')};
  gap: 16px;
  margin-top: 20px;
  margin-left: 60px;
  max-height: 164px;
  flex-wrap: nowrap;
  flex-direction: column;
  scrollbar-width: thin;
  position: relative;
  top: -10px;
  overflow-x: auto;
  z-index: 1;
`;
